import { getFordQueueDisplayName } from '@rsos/utils/getFordQueueDisplayName';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import { type EmergencyCallsMap } from '@rsos/utils/isCallerIDFromOrg';
import { isFordCallerID } from '@rsos/utils/isFordCallerID';

/**
 * Primary label for a call in the event pane / other phone-centric surfaces.
 * Ford VIN-keyed rows use make+model (or "Ford Vehicle"); everyone else keeps
 * the existing human phone formatting.
 */
export const getEmergencyCallDisplayName = (
  callerID: string | null | undefined,
  emergencyCalls: EmergencyCallsMap | null | undefined,
): string => {
  if (!callerID) {
    return '';
  }

  if (isFordCallerID(emergencyCalls, callerID)) {
    const additionalData = emergencyCalls?.[callerID]?.additionalData;
    const fordAdr =
      additionalData &&
      typeof additionalData === 'object' &&
      'ford' in additionalData
        ? (additionalData as { ford?: unknown }).ford
        : undefined;
    return getFordQueueDisplayName(
      fordAdr as Parameters<typeof getFordQueueDisplayName>[0],
    );
  }

  return formatInternationalPhoneNumberHuman(callerID);
};

export default getEmergencyCallDisplayName;
